import { useEffect, useRef } from 'react';

import clsx from 'clsx';

import {
  VALUE_SLIDER_BACKGROUND,
  VALUE_SLIDER_BACKGROUND_IMAGE,
  VALUE_SLIDER_BACKGROUND_SIZE,
  VALUE_SLIDER_GRADIENT,
  VALUE_SLIDER_RANGE_INPUT,
  VALUE_SLIDER_WRAPPER
} from './value-slider-config';

type ValueSliderProps = {
  min?: number;
  max?: number;
  value: number;
  onChange: (value: number) => void;
  className?: string;
  testId?: string;
};

export const ValueSlider = ({
  min = -100,
  max = 100,
  value,
  onChange,
  className,
  testId
}: ValueSliderProps) => {
  const opacityRef = useRef<HTMLInputElement | null>(null);
  const dragValueRef = useRef<number>(value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dragValueRef.current = e.currentTarget.valueAsNumber;
  };

  const handleCommit = () => {
    onChange(dragValueRef.current);
  };

  useEffect(() => {
    if (opacityRef.current) {
      opacityRef.current.value = String(value);
      dragValueRef.current = value;
    }
  }, [value]);

  return (
    <div data-testid={testId} className={clsx(VALUE_SLIDER_WRAPPER, className)}>
      <div
        className={VALUE_SLIDER_BACKGROUND}
        style={{
          backgroundImage: VALUE_SLIDER_BACKGROUND_IMAGE,
          backgroundSize: VALUE_SLIDER_BACKGROUND_SIZE
        }}
      />
      <div className={VALUE_SLIDER_GRADIENT} />
      <input
        ref={opacityRef}
        type='range'
        min={min}
        max={max}
        defaultValue={value}
        onChange={handleChange}
        onMouseUp={handleCommit}
        onTouchEnd={handleCommit}
        className={VALUE_SLIDER_RANGE_INPUT}
        aria-label='value-slider'
      />
    </div>
  );
};
